import React, { useState } from "react";
import { AddAddress } from "../../apis/Api";
import { generateRandomId } from "../../utils/helper";
import toast from "react-hot-toast";


const AddressModal = ({ setAddresses ,setUpdateTrigger }) => {
  const [newAddress, setNewAddress] = useState(""); // State for address
  const [newAddressType, setNewAddressType] = useState(""); // State for address type
  const [error, setError] = useState(""); // State for error message
  const [loading ,setLoading] = useState(false)
  // Function to handle address submission


  
  const PostAddress = async newAddress => {
    
    setLoading(true);
    const token =  localStorage.getItem('token');
    if (token) {
      console.log(newAddress)

      try {
        const response = await AddAddress({
          cust_token: token,
          address: newAddress,
        });
        if (response && response.status === 200) {
          toast.success('Address successfully added'
          );
        console.log('success')
        setNewAddress('')
        setNewAddressType('')
        setUpdateTrigger(prev => prev + 1); // Trigger re-render
      }
      } catch (error) {
        console.log('error adding address', error);
        // Toast.show({
        //   type: 'error',
        //   text1: `${error.message}`,
        // });
      } finally {

        setLoading(false);
      }
    } else {
    //   Toast.show({
    //     type: 'error',
    //     text1: 'Please create a new cart',
    //   });
    }
  };
  const addAddress = () => {
    if (newAddress.trim() === "" || newAddressType.trim() === "") {
      setError("Address and Type cannot be empty");
      return;
    }

    const newAddrObj = [{
      id: generateRandomId(), // Unique ID (timestamp-based)
      type: newAddressType,
      address: newAddress,
    }];

    setAddresses((prev) => [...prev, newAddrObj]); // Update parent state

    // Clear input fields and close modal
    setNewAddress("");
    setNewAddressType("");
    setError("");
    PostAddress(newAddrObj)
    // Close modal using Bootstrap
    document.getElementById("closeModalButton").click();
  };

  return (
    <div className="container mt-3">
      {/* Button to Open Modal */}

      {/* Modal */}
      <div className="modal fade" id="addressModal" tabIndex="-1" aria-labelledby="addressModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content rounded-3 p-3">
            <div className="modal-header border-0">
              <h5 className="modal-title fw-bold">Add New Address</h5>
              <button type="button" id="closeModalButton" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div className="modal-body">
              {/* Address Type Input */}
              <input
                type="text"
                className="form-control mb-3 border-0 shadow-sm p-2"
                placeholder="Enter address type (e.g., Home, Office)"
                value={newAddressType}
                onChange={(e) => setNewAddressType(e.target.value)}
                style={{ borderRadius: "10px", background: "#F8F8F8" }}
              />

              {/* Full Address Input */}
              <input
                type="text"
                className="form-control mb-3 border-0 shadow-sm p-2"
                placeholder="Enter full address"
                value={newAddress}
                onChange={(e) => setNewAddress(e.target.value)}
                style={{ borderRadius: "10px", background: "#F8F8F8" }}
              />

              {/* Error Message */}
              {error && <p className="text-danger">{error}</p>}
            </div>

            <div className="modal-footer border-0 d-flex flex-column">
              <button className="btn w-100 text-white fw-bold" style={{ background: "#6CC51D", borderRadius: "10px", height: "40px" }} onClick={addAddress}>
                Add Address
              </button>
              <button className="btn w-100 mt-2 fw-bold" data-bs-dismiss="modal" style={{ background: "#6CC51D", color: "#fff", borderRadius: "10px", height: "40px" }}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddressModal;
